<template>
  <div class="row">
    <div class="col-md-6">
      <user-password-change
          v-bind:component-title="'Zmień moje hasło'">
      </user-password-change>
    </div>
  </div>
</template>

<script>
  import UserPasswordChange from '@Component/user-password-change';

  export default {
    components: {
      UserPasswordChange,
    },
    data() {
      return {};
    },
    methods: {}
  };
</script>

<style scoped>

</style>
